export default __webpack_public_path__ + "static/media/profile.f3e6b653.jpg";